import type { ReactNode } from "react";
import { Check } from "lucide-react";
import { cn } from "../utils/cx.js";

export interface StepItem {
  title: ReactNode;
  description?: ReactNode;
}

export interface StepsProps {
  current: number;
  items: StepItem[];
  direction?: "horizontal" | "vertical";
  className?: string;
}

export function Steps({ current, items, direction = "horizontal", className }: StepsProps) {
  const vertical = direction === "vertical";
  return (
    <ol className={cn("flex", vertical ? "flex-col gap-4" : "items-start gap-2", className)}>
      {items.map((it, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <li
            key={i}
            className={cn("flex gap-3", vertical ? "flex-row" : "flex-1 flex-col items-center text-center")}
          >
            <div className={cn("flex items-center gap-3", !vertical && "w-full")}>
              <span
                className={cn(
                  "flex size-7 shrink-0 items-center justify-center rounded-full border text-xs font-medium",
                  done && "border-primary bg-primary text-primary-foreground",
                  active && "border-primary text-primary",
                  !done && !active && "border-border text-muted-foreground",
                )}
              >
                {done ? <Check className="size-4" /> : i + 1}
              </span>
              {!vertical && i < items.length - 1 && (
                <span className={cn("h-px flex-1", done ? "bg-primary" : "bg-border")} />
              )}
            </div>
            <div className={cn(vertical ? "" : "mt-2")}>
              <div
                className={cn("text-sm font-medium", active ? "text-foreground" : "text-muted-foreground")}
              >
                {it.title}
              </div>
              {it.description != null && (
                <div className="text-xs text-muted-foreground">{it.description}</div>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
